const booking = {
  bookingInformation: "Impormasyon sa Pag-book", // translated 
  cancellationPolicy: "Patakaran sa Pagkansela", // translated 
  ourCancellationPolicy: "Ang Aming Patakaran sa Pagkansela", // translated 
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "Ito ay pumapalit sa anumang patakaran sa pagkansela sa mga komento sa itaas.", // translated 
  thisBookingIsNonNefundable: "Hindi mare-refund ang booking na ito", // translated 
  paymentTerms: "Mga Tuntunin sa Pagbabayad", // translated 
  paymentWillBeTakenFromYourDefault: "Ang bayad ay kukunin mula sa iyong default", // translated 
  paymentMethod: "paraan ng pagbabayad", // translated 
  afterTheFreeCancellationPeriodIfApplicable:
    "pagkatapos ng libreng panahon ng pagkansela kung naaangkop", // translated 
  prebook: "Prebook", // translated 
  guests: "Mga Bisita", // translated 
  payment: "Pagbabayad", // translated 
  byClicking: "Sa pamamagitan ng pag-click", // translated 
  youAreAgreeingToOur: "sumasang-ayon ka sa aming", // translated 
  termsAndConditions: "Mga Tuntunin at Kundisyon", // translated 
  lastBookableDate: "Huling Petsa ng Pag-book", // translated 
  customerRemarksTextfield: "Mga Paalala ng Customer", // translated 
  request: "Kahilingan", // translated 
};


export default booking;
